export default __webpack_public_path__ + "media/metronic/_theme/media/demos/preview/demo10-7b845a9e08b41ec854959017065efa2f.jpg";